<template>
  <div class="bg-default-dashboard">
      <div class=" py-lg-8 pt-lg-5">
          <b-container fluid style="width: 90%;">
              <!-- <div class="header-body "  > -->
              <b-row class="mb-2">
                  <b-col>
                      <h1 class="text-white">Project List</h1>
                  </b-col>
              </b-row>
              <b-row>
                  <div class="d-flex flex-column h-100 w-100 p-2">
                      <div class="d-flex flex-column h-100 w-100 flex-grow-1 flex-shrink-1">
                          <div style="padding: 4px;">
                              <div style="float: right;" class="d-flex">
                                  <input class="mr-2 form-control d-inline-block" @keyup="onQuickFilterChanged"
                                      type="text" id="quickFilterInput" placeholder="Type text to filter..." />
                                <!--
                                  <button class="btn btn-primary mr-2" :disabled="!showGrid" @click="showGrid = false"
                                      style="white-space: nowrap;">Destroy Grid</button>
                                  <button class="btn btn-primary" :disabled="showGrid" @click="showGrid = true"
                                      style="white-space: nowrap;">Create Grid</button>-->
                              </div>
                          </div>
                          <div style="clear: both;"></div>
                          <div v-if="showGrid" class="d-flex flex-column flex-grow-1 flex-shrink-1">
                              <div style="padding: 4px;" class="btn-toolbar">
                                  <span>
                                        <button class="btn btn-primary mx-1" @click="api.selectAll()">Select
                                          All</button>
                                        <button class="btn btn-primary mx-1" @click="api.deselectAll()">Clear
                                          Selection</button>
                                        <button class="btn btn-primary mx-1" v-on:click="toggleSideBar()">
                                            Show Side Bar
                                        </button>
                                  </span>
                                  <span>
                                      <b-button size="md" variant="success" @click="openPlannerSite">Site List</b-button>
                                      <b-button size="md" variant="success" @click="openPlannerLandingPage">Main Menu</b-button>
                                  </span>
                              </div>

                              <ag-grid-vue style="width: 100%;" class="flex-grow-1 flex-shrink-1 ag-theme-alpine"
                                  :columnDefs="columnDefs" :rowData="rowData" :sideBar="sideBar" :modules="modules"
                                  :defaultColDef="{
                                      sortable: true,
                                      resizable: true,
                                      filter: true,
                                      floatingFilter: true,
                                  }" 
                                  :statusBar="statusBar" 
                                  :groupHeaders="true" :suppressRowClickSelection="true"
                                  :allowContextMenuWithControlKey="true" rowSelection="multiple" @grid-ready="onReady"
                                  @cell-clicked="onCellClicked" @cell-double-clicked="onCellDoubleClicked"
                                  @cell-context-menu="onCellContextMenu" @cell-value-changed="onCellValueChanged"
                                  @cell-focused="onCellFocused" @row-selected="onRowSelected"
                                  @selection-changed="onSelectionChanged" @filter-modified="onFilterModified"
                                  @virtual-row-removed="onVirtualRowRemoved" @row-clicked="onRowClicked"
                                  @column-everything-changed="onColumnEvent" @column-row-group-changed="onColumnEvent"
                                  @column-value-Changed="onColumnEvent" @column-moved="onColumnEvent"
                                  @column-visible="onColumnEvent" @column-group-Opened="onColumnEvent"
                                  @column-resized="onColumnEvent" @column-pinned-count-changed="onColumnEvent"
                                  :getContextMenuItems="getContextMenuItems" :rowClassRules="rowClassRules">
                              </ag-grid-vue>
                          </div>
                      </div>
                  </div>
              </b-row>
          </b-container>

      </div>


  </div>
</template>

<script>
import { AgGridVue } from "@ag-grid-community/vue";


// import DateComponent from './DateComponent.vue';
import HeaderGroupComponent from './HeaderGroupComponent.vue';
import axios from '@/util/axios';
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ColumnsToolPanelModule } from "@ag-grid-enterprise/column-tool-panel";
import { ExcelExportModule } from "@ag-grid-enterprise/excel-export";
import { FiltersToolPanelModule } from "@ag-grid-enterprise/filter-tool-panel";
import { SparklinesModule } from "@ag-grid-enterprise/sparklines";
import { GridChartsModule } from "@ag-grid-enterprise/charts";
import { MasterDetailModule } from "@ag-grid-enterprise/master-detail";
import { MenuModule } from "@ag-grid-enterprise/menu";
import { MultiFilterModule } from "@ag-grid-enterprise/multi-filter";
import { RangeSelectionModule } from "@ag-grid-enterprise/range-selection";
import { RichSelectModule } from "@ag-grid-enterprise/rich-select";
import { RowGroupingModule } from "@ag-grid-enterprise/row-grouping";
import { ServerSideRowModelModule } from "@ag-grid-enterprise/server-side-row-model";
import { SetFilterModule } from "@ag-grid-enterprise/set-filter";
import { SideBarModule } from "@ag-grid-enterprise/side-bar";
import { StatusBarModule } from "@ag-grid-enterprise/status-bar";
import { ViewportRowModelModule } from "@ag-grid-enterprise/viewport-row-model";
import { ClipboardModule } from "@ag-grid-enterprise/clipboard";
import { LoginURL, clientId, clientSecret, apiDomain, getHeader, getcurrentDate } from '@/assets/js/config.js';
import "@ag-grid-enterprise/core";
import moment from "moment";

// const api = shallowRef();

export default {
  created() {
    const LoginUser = JSON.parse(window.localStorage.getItem("loginUser"));

    this.myUserID = LoginUser;
    var project_site_access = JSON.parse(window.localStorage.getItem("project_site_access"));
    
    var project_site_access = JSON.parse(
            window.localStorage.getItem("project_site_access")
    );

      this.getProjectTypeListing();
      this.getProjectManagerListing();
      this.getProjectEngineerListing();
      this.getBusinessDevelopmentListing();
      this.getSafetyOfficerListing();

 },
  data() {
      return {
          model: {
              project_id: null,
              developer_id: "x",
              developer_code: null,
              developer_name: null,
              project_type_id: "x",
              project_type_name: null,
              project_manager: "x",
              project_engineer: "x",
              project_business_development: "x",
              project_safety: "x",
              project_name: null,
              project_ppa_counter_party: null,
              project_ppa_start_date: null,
              project_ppa_approved_capacity: null,
              project_watt_class: null,
              project_tag: null,
              project_industry_category_id: "x",
          },
          industry_category: [],
          industry_category2:[],
          api: null,
          columnDefs: null,
          savedFilterModel: null,
          showGrid: false,
          rowClassRules: null,
          rowCount: null,
          modules: [
              ClientSideRowModelModule,
              ColumnsToolPanelModule,
              ExcelExportModule,
              FiltersToolPanelModule,
              SparklinesModule,
              GridChartsModule,
              MasterDetailModule,
              MenuModule,
              MultiFilterModule,
              RangeSelectionModule,
              RichSelectModule,
              RowGroupingModule,
              ServerSideRowModelModule,
              SetFilterModule,
              SideBarModule,
              StatusBarModule,
              ViewportRowModelModule,
              ClipboardModule
          ],

          rowData: [],
          sideBar: false,
          project_types: [],
          project_managers: [],
          project_managers_index: [],
          project_engineers: [],
          project_engineers_index: [],
          project_business_development: [],
          project_business_development_index: [],
          project_safety: [],
          project_safety_index: [],
          project_business_development_options: [],
          project_safety_options: [],
          developer_options:[],
          developer_index:[],
          statusBar:
          {
            statusPanels: [
              { statusPanel: "agTotalAndFilteredRowCountComponent" },
              {statusPanel: "agTotalRowCountComponent" },
              {statusPanel: "agFilteredRowCountComponent" },
              {statusPanel: "agSelectedRowCountComponent" },
              {statusPanel: "agAggregationComponent" },
            ],
          },
          filter: {
            developers: [],
            project_managers: [],
            project_type: [],
            project_name:null,
            },
          myUserID : null,
          myUserDetail:null,
      }
  },
  components: {
      AgGridVue,
  },

  methods: {

        errorFunction(err,info) {
            this.error = `An error occurred: ${err.message}`;
            console.error(err, info);
            return false; // prevents the error from propagating further
        },

        openPlannerLandingPage()
        {
            this.$router.push('plannerLandingPage');
        },
        openPlannerSite()
        {
            this.$router.push('plannersite');
        },
      //01. To provide all the options

      //01.01 GET BD LIST
      getBusinessDevelopmentListing() {
        axios.get(apiDomain + 'lookup/user_list/Business_Development', { headers: getHeader() })
          .then ( response => {
              if (response.status === 200)
              {
                for (let i = 0; i < response.data.data.length; i++) {
                  this.project_business_development_options.push(response.data.data[i].name);
                  this.project_business_development_index.push({id:response.data.data[i].id,value:response.data.data[i].name})
                }
                //console.log(this.project_business_development_options);
              }
          })
          .catch ( error => {
              console.log(error.response.status)
              this.errorFunction(error, "Business Developer Information")
          } );
      },



      //01.03 GET PROJECT TYPE LIST
      getProjectTypeListing() {
          axios
              .get(apiDomain + "setup/project_type", { headers: getHeader() })
              .then((response) => {
                  if (response.status === 200) {
                      for (let i = 0; i < response.data.data.length; i++) {
                          this.project_types.push(response.data.data[i].project_type);
                      }

                      // console.log(this.project_types);
                  }
              })
              .catch((error) => {
                  console.log(error.response.status);
                  this.errorFunction(error, "Project Type");
              });
      },

      //01.04 GET PROJECT MANAGER TYPE LIST
      getProjectManagerListing() {
          axios.get(apiDomain + 'lookup/user_list/Project_Manager', { headers: getHeader() })
              .then(response => {
                  if (response.status === 200) {
                      for (let i = 0; i < response.data.data.length; i++) {
                          this.project_managers.push(response.data.data[i].name);
                          this.project_managers_index.push({id:response.data.data[i].id,value:response.data.data[i].name})
                      }
                      // console.log("Project Managers");
                      // console.log(this.project_managers_index);
                  }
              })
              .catch(error => {
                  console.log(error.response.status)
                  this.errorFunction(error, "Project Manager")
              });
      },

      //01.05 GET ENGINEER LIST
      getProjectEngineerListing() {
          axios.get(apiDomain + 'lookup/user_list/Engineer', { headers: getHeader() })
              .then(response => {
                  if (response.status === 200) {
                      for (let i = 0; i < response.data.data.length; i++) {
                          this.project_engineers.push(response.data.data[i].name);
                          this.project_engineers_index.push({id:response.data.data[i].id,value:response.data.data[i].name});
                      }
                      //console.log(this.project_engineers);
                  }
              })
              .catch(error => {
                  console.log(error.response.status)
                  this.errorFunction(error, "Engineer Information")
              });
      },

      //01.06 GET SAFETY OFFICER LIST
      getSafetyOfficerListing() {
        axios.get(apiDomain + 'lookup/user_list/Safety', { headers: getHeader() })
        .then ( response => {
            if (response.status === 200)
            {
              this.project_safety = response.data.data;
              for (let i = 0; i < this.project_safety.length; i++) {
                this.project_safety_options.push(this.project_safety[i].name);
                this.project_safety_index.push({id:response.data.data[i].id,value:response.data.data[i].name});
              }
              //console.log(this.project_safety_options);
            }
        })
        .catch ( error => {
            console.log(error.response.status)
            this.errorFunction(error, "Safety Officer Information")
        } );
      },

      //01.07 SAVE THE RECORD
      onCellValueChanged(event) {
          this.model.project_id = event.data.project_id;
          this.model.project_name = event.data.project_name;
          this.model.project_manager = this.searchKeyword(event.data.project_manager.name,this.project_managers_index);
          this.model.project_engineer = this.searchKeyword(event.data.project_engineer.name,this.project_engineers_index);
          this.model.project_business_development = this.searchKeyword(event.data.project_business_development.name,this.project_business_development_index);
          this.model.project_safety = this.searchKeyword(event.data.project_safety.name,this.project_safety_index);
          this.model.project_type_id = event.data.project_type.project_type_id;
          this.model.developer_id = event.data.developer.developer_id;
          this.model.project_ppa_start_date = event.data.project_ppa_start_date;
          this.model.project_ppa_approved_capacity = event.data.project_ppa_approved_capacity;
          //this.model.project_ppa_approved_capacity = parseFloat(event.data.project_ppa_approved_capacity.replace(/,/g, ""));
          this.model.project_industry_category_id = event.data.project_industry_category_id;
          if (event.data.project_watt_class !== null) {
              this.model.project_watt_class = parseFloat(event.data.project_watt_class.replace(/,/g, ""));
          }

          axios.put(apiDomain + 'project/project/' + event.data.project_id, this.model, { headers: getHeader() })
              .then(response => {
                  if (response.status === 200) {
                      this.$notify({
                          message:
                              '<b>Update Project : ' + this.model.project_name + '</b> - Successfully Updated.',
                          timeout: 10000,
                          icon: 'ni ni-bell-55',
                          type: 'default',
                      });
                      //   this.$router.back()

                  }
              })
              .catch(error => {
                  console.log(error.response.data.errors)
                  this.errorFunction(error, "Project Information")
              });

      },

      //01.08 TO SEARCH THE ID BASED ON KEYWORD SEARCH IN VALUE PROPERTY
      searchKeyword(strSearch,arrToSearch) 
      {
        //console.log("keyword : " + strSearch);
        //console.log(arrToSearch);
        const result = arrToSearch.find(item =>
          item.value.includes(strSearch)
        );
        let foundIndex = result ? result.id : null;
        //console.log("foundIndex : " + foundIndex);
        return foundIndex;
      },

      searchKeywordDeveloper(strSearch,arrToSearch) 
      {
        //console.log("keyword : " + strSearch);
        //console.log(arrToSearch);
        const result = arrToSearch.find(item =>
          item.value.includes(strSearch)
        );
        let foundIndex = result ? result.id : null;
        //console.log("foundIndex : " + foundIndex);
        return foundIndex;
      },

      saveFilterModel() {

          this.savedFilterModel = this.api.getFilterModel();
          var keys = Object.keys(this.savedFilterModel);
          var savedFilters = keys.length > 0 ? keys.join(", ") : "(none)";
          document.querySelector("#savedFilters").textContent = savedFilters;
      },

      restoreFilterModel() {
          this.api.setFilterModel(this.savedFilterModel);
      },
      clearFilters() {
          this.api.setFilterModel(null);
          document.querySelector("#savedFilters").textContent = "(none)";
      },
      rowClassRule() {
          //this.rowClassRules = {
              // row style function
              //"sick-days-warning": (params) => {
                  // console.log("this", params.data.project_start_date);
                  //   var numSickDays = params.data.sickDays;
                //  return params.data.project_start_date === "2024-09-30"
              //},
              // row style expression
              // "sick-days-breach": "data.sickDays >= 8",
          //};
      },

      getDataToShow() {
      //_ role planner display all project and sites
      //_ role project manager leader - list all project and site for all project manager under him/her
      //_ role project manager - list all project and site only for his/her own
      // console.log('>>> func getDataToShow');
      // console.log(this.obj_user.info);

      axios.get(apiDomain+'api/get_user_project_developer/'+this.myUserID.id,{headers: getHeader()})
            .then ( response => {
                this.myUserDetail = response.data.data;
                for(let i = 0; i < this.myUserDetail.developers.length; i++)
                {
                  this.filter.developers.push(this.myUserDetail.developers[i].developer.developer_id);
                }
                console.log('Filter developer');
                console.log(this.filter.developers);

              })

            .catch(error => {
              this.errorFunction(error, this.title)
            })

            .finally(() => {

            this.filter.project_type.push(1);
            this.createRowData();

        });
    },
      
      async createRowData() {
        try {
         const response = await axios.post('project/get_project_listing',this.filter,
        {
           headers: getHeader(),
        });

        const data = response.data.data;
        console.log("Data loaded:", data);

        this.rowData = [];

        // Check if data has items to process
        if (data && data.length > 0) {
          console.log("Processing data...");

          // Process each item in the data array
          for (let i = 0; i < data.length; i++) {
            let parsedValue;

            const item = data[i];

            // Check and convert project_total_capacity field
            if (typeof item.project_ppa_approved_capacity === 'string') {
              // Remove commas and parse to number
              parsedValue = Number(item.project_ppa_approved_capacity.replace(/,/g, ''));
            } else {
              parsedValue = Number(item.project_ppa_approved_capacity);
            }

            // Ensure parsedValue is a valid number
            if (isNaN(parsedValue)) {
              parsedValue = 0; // Default to 0 if NaN
            }

            parsedValue = Number(parsedValue.toFixed(3));
            // Add processed item to rowData
            this.rowData.push({
              ...item,
              project_ppa_approved_capacity: parsedValue  // Round and set the integer value
            });
          }

        console.log("Final rowData:", this.rowData);
       } 
       
        } 
       catch (error) {
         this.errorFunction(error, this.title);
       } 
       
       finally {
         //this.getMilestone();
       }
      },


      createColumnDefs() {
          this.columnDefs = [
              {
                  headerName: '#', minWidth: 60, width: 60, checkboxSelection: true, sortable: false,
                  suppressHeaderMenuButton: true, pinned: true
              },
              {
                  headerName: "Project Name", 
                  field: "project_name", 
                  width: 200,
                  pinned: true, 
                  floatingFilter: true,
              },
              { 
                headerName: "Developer", 
                  field: "developer.developer_name", 
                  width: 200,
                  enableRowGroup:true,
                  floatingFilter: true,
              },
              {
                  headerName: "Type", 
                  field: "project_type.project_type", 
                  width: 110,
                  enableRowGroup:true, 
                  suppressHeaderMenuButton: true, 
                  floatingFilter: true,
              },
              {
                    headerName: "PPA Counter Party", 
                    field: "project_ppa_counter_party", 
                    width: 150, 
                    suppressHeaderMenuButton: true,
                    editable: true,
                    enableRowGroup:true, 
                    cellClass: 'agColumnEditable'
              },
              {
                  headerName: "PPA Sign Date", 
                  field: "project_ppa_start_date", 
                  width: 150,
                  suppressHeaderMenuButton: true,
                  enableRowGroup:true,
                  cellRenderer: (data) => { return (data.value) ? moment(data.value).format('DD MMM YYYY') : '' }
              },
              {
                  headerName: "PPA Total Capacity(kWp)", 
                  field: "project_ppa_approved_capacity", 
                  type: 'rightAligned', 
                  width: 150, 
                  suppressHeaderMenuButton: true,
                  editable: true, 
                  cellClass: 'agColumnEditable ag-right-aligned-cell',
                  enableValue: true,
                  //cellRenderer: (data) => {
                    //return data.value.toFixed(3);
                    //}
               },
               {
                  headerName: "Watt Class", 
                  field: "project_watt_class", 
                  width: 150, 
                  suppressHeaderMenuButton: true,
                  enableRowGroup:true,
                  editable: true, 
                  cellClass: 'agColumnEditable ag-right-aligned-cell',
                  cellRenderer: data => {
                  return Math.floor(data.value);
                }
              },
              {
                  headerName: "Project Engineer", 
                  field: "project_manager.name", 
                  width: 150, 
                  suppressHeaderMenuButton: true,
                  cellEditor: "agSelectCellEditor", 
                  cellEditorParams: { values: this.project_managers }, 
                  filter: 'agSetColumnFilter',
                  enableRowGroup:true, 
                  floatingFilter: true, 
                  editable: true,
              },
              {
                  headerName: "Engineer", 
                  field: "project_engineer.name", 
                  width: 150, 
                  suppressHeaderMenuButton: true,
                  cellEditor: "agSelectCellEditor", 
                  cellEditorParams: { values: this.project_engineers }, 
                  filter: 'agSetColumnFilter',
                  enableRowGroup:true, 
                  floatingFilter: true, 
                  editable: true,
              },
              {
                  headerName: "Business Development", 
                  field: "project_business_development.name", 
                  width: 150, 
                  suppressHeaderMenuButton: true,
                  cellEditor: "agSelectCellEditor", 
                  cellEditorParams: { values: this.project_business_development_options }, 
                  filter: 'agSetColumnFilter',
                  enableRowGroup:true, 
                  floatingFilter: true, 
                  editable: true,
              },
              {
                  headerName: "Safety Officer", 
                  field: "project_safety.name", 
                  width: 150, 
                  suppressHeaderMenuButton: true,
                  enableRowGroup:true,
                  cellEditor: "agSelectCellEditor", 
                  cellEditorParams: { values: this.project_safety_options }, 
                  filter: 'agSetColumnFilter', 
                  floatingFilter: true, 
                  editable: true,
              },
          ];


      },
 


      pad(num, totalStringSize) {
          let asString = num + "";
          while (asString.length < totalStringSize) asString = "0" + asString;
          return asString;
      },

      onReady(params) {
          //console.log('onReady');
          this.api = params.api;
          this.api.sizeColumnsToFit();
          // params.api.getToolPanelInstance("filters").expandFilters();
      },
      // onBtnUpdate(){
      //     document.querySelector("#csvResult").value = this.api.getDataAsCsv({
      //         processCellCallback: function(cell) {
      //       // Manipulate the value however you need.
      //       return cell.value;
      //     },
      //     });
      // },

      onCellClicked(event) {
          //     this.model.project_id=event.data.project_id;
          //     this.model.project_name=event.data.project_name;
          //     this.model.project_manager=event.data.project_manager.id;
          //     this.model.project_engineer=event.data.project_engineer.id;
          //     this.model.project_business_development=event.data.project_business_development.id;
          //     this.model.project_safety=event.data.project_safety.id;
          //     this.model.project_type_id=event.data.project_type.project_type_id;
          //     this.model.developer_id=event.data.developer.developer_id;
          //     this.model.project_ppa_start_date=event.data.project_ppa_start_date;
          //     this.model.project_ppa_approved_capacity=parseFloat(event.data.project_ppa_approved_capacity.replace(/,/g, ""));
          //     this.model.project_industry_category_id=event.data.project_industry_category_id;
          //         if (event.data.project_watt_class !== null) {
          //         this.model.project_watt_class=parseFloat(event.data.project_watt_class.replace(/,/g, ""));
          //         }
          // //console.log(event);


          //console.log('onCellClicked: ' + event.rowIndex + ' ' + event.colDef.field);
      },

      // onCellValueChanged(event) {
      //     this.model.project_id = event.data.project_id;
      //     this.model.project_name = event.data.project_name;
      //     this.model.project_manager = event.data.project_manager.id;
      //     this.model.project_engineer = event.data.project_engineer.id;
      //     this.model.project_business_development = event.data.project_business_development.id;
      //     this.model.project_safety = event.data.project_safety.id;
      //     this.model.project_type_id = event.data.project_type.project_type_id;
      //     this.model.developer_id = event.data.developer.developer_id;
      //     this.model.project_ppa_start_date = event.data.project_ppa_start_date;
      //     this.model.project_ppa_approved_capacity = parseFloat(event.data.project_ppa_approved_capacity.replace(/,/g, ""));
      //     this.model.project_industry_category_id = event.data.project_industry_category_id;
      //     if (event.data.project_watt_class !== null) {
      //         this.model.project_watt_class = parseFloat(event.data.project_watt_class.replace(/,/g, ""));
      //     }

      //     //console.log('onCellValueChanged: ' + event.oldValue + ' to ' + event.newValue);
      //     //console.log(event.data);

      //     axios.put(apiDomain + 'project/project/' + event.data.project_id, this.model, { headers: getHeader() })
      //         .then(response => {
      //             if (response.status === 200) {
      //                 this.$notify({
      //                     message:
      //                         '<b>Update Project : ' + this.model.project_name + '</b> - Successfully Updated.',
      //                     timeout: 10000,
      //                     icon: 'ni ni-bell-55',
      //                     type: 'default',
      //                 });
      //                 //   this.$router.back()

      //             }
      //         })
      //         .catch(error => {
      //             console.log(error.response.data.errors)
      //             this.errorFunction(error, "Project Information")
      //         });

      // },

      onCellDoubleClicked(event) {
          //console.log('onCellDoubleClicked: ' + event.rowIndex + ' ' + event.colDef.field);
      },

      onCellContextMenu(event) {

          //console.log('onCellContextMenu: ' + event.rowIndex + ' ' + event.colDef.field);

      },

      onCellFocused(event) {

          //console.log('onCellFocused: (' + event.rowIndex + ',' + event.colIndex + ')');
      },

      // taking out, as when we 'select all', it prints to much to the console!!
      // eslint-disable-next-line
      onRowSelected(event) {
          // console.log('onRowSelected: ' + event.node.data.name);
      },

      onSelectionChanged() {
          //console.log('selectionChanged');
      },

      onFilterModified() {
          //console.log('onFilterModified');
      },

      // eslint-disable-next-line
      onVirtualRowRemoved(event) {
          // because this event gets fired LOTS of times, we don't print it to the
          // console. if you want to see it, just uncomment out this line
          // console.log('onVirtualRowRemoved: ' + event.rowIndex);
      },

      onRowClicked(event) {
          this.api.processCellCallback = function (cell) {
              // Manipulate the value however you need.
              //console.log("cell" + cell.value);
              return cell.value;
          };
          //console.log('onRowClicked: ' + event.node.data.name);
      },

      onQuickFilterChanged(event) {
          this.api.setQuickFilter(event.target.value);
      },

      // here we use one generic event to handle all the column type events.
      // the method just prints the event name
      onColumnEvent(event) {
          //console.log('onColumnEvent: ' + event);
      },
      toggleSideBar() {
          this.sideBar = !this.sideBar;
          this.api.setSideBar(this.sideBar);
      },
      getContextMenuItems(event) {
          return [
              'copy',
              'copyWithHeaders',
              'paste',
              'separator',
              {
                  name: 'Export',
                  subMenu: [
                      {
                          name: 'CSV Export',
                          action: () => {
                              this.api.exportDataAsCsv({
                                  // skipColumnGroupHeaders:true,
                                  onlySelected: true
                              });
                          },
                          icon: '<span class="ag-icon ag-icon-csv" unselectable="on" role="presentation"></span>',
                      },
                      {
                          name: 'Excel Export',
                          action: () => { this.api.exportDataAsExcel({ onlySelected: true }) },
                          icon: '<span class="ag-icon ag-icon-excel" unselectable="on" role="presentation"></span>',
                      },
                  ],
                  icon: '<span class="ag-icon ag-icon-save" unselectable="on" role="presentation"></span>',
              },
              'separator',
              'chartRange',
              'pivotChart',
              'separator',
              'resetColumns',
              'separator',
              'toolPanel',
          ];
      },
  },
  beforeMount() {
      this.api = {};
      this.getDataToShow();
      //this.createRowData();
      this.createColumnDefs();
      this.rowClassRule();
      this.showGrid = true;

  }
}

// function skillsCellRenderer(params) {
//     let data = params.data;
//     let skills = [];
//     RefData.IT_SKILLS.forEach(function (skill) {
//         if (data && data.skills && data.skills[skill]) {
//             skills.push('<img src="https://www.ag-grid.com/example-assets/skills/' + skill + '.png" width="16px" title="' + skill + '" />');
//         }
//     });
//     return skills.join(' ');
// }
function lookupValue(mappings, key) {
  //    console.log("thiss",mappings[key])
     
  // return mappings[key];

  mappings.forEach(element => {
      if (element.id===key)
  {
//console.log("key",key)
//console.log("element id",element.id)
//console.log("element.name",element.name)
      return "hello"
      
  }
 
});
  
};
var dateFilterParams = {
  browserDatePicker: true,
  buttons: ['reset', 'apply', 'cancel'],
  closeOnApply: true,

  comparator: (filterLocalDateAtMidnight, cellValue) => {
      //console.log("cellValue", cellValue)
      var dateAsString = cellValue;
      if (dateAsString == null) return -1;
      var dateParts = dateAsString.split("-");
      var cellDate = new Date(
          Number(dateParts[0]),
          Number(dateParts[1]) - 1,
          Number(dateParts[2]),
      );
      if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
          return 0;
      }
      if (cellDate < filterLocalDateAtMidnight) {
          return -1;
      }
      if (cellDate > filterLocalDateAtMidnight) {
          return 1;
      }
      return 0;
  },

}


function createRandomPhoneNumber() {
  let result = '+';
  for (let i = 0; i < 12; i++) {
      result += Math.round(Math.random() * 10);
      if (i === 2 || i === 5 || i === 8) {
          result += ' ';
      }
  }
  return result;
}


</script>

<style>
.sick-days-warning {
  background-color: #cc693344;
}

.sick-days-breach {
  background-color: #cc333344;
}

.ag-root-wrapper-body.ag-layout-normal {
  height: 700px
}

.ag-cell {
  padding-top: 2px !important;
  padding-bottom: 2px !important;
}

label {
  font-weight: normal !important;
}

.bg-default-dashboard {
  background-color: #082A2F;
  /* background-color: #f1e5e9; */
  /* background-size: cover; */
  /* position:fixed; */
  padding: 0;
  margin: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

/* .ag-theme-alpine {
min-height: 500px;
height: 500px;
} */
.div-percent-bar {
  display: inline-block;
  height: 100%;
  position: relative;
  z-index: 0;
}

.div-percent-value {
  position: absolute;
  padding-left: 4px;
  font-weight: bold;
  font-size: 13px;
  z-index: 100;
}

.div-outer-div {
  display: inline-block;
  height: 100%;
  width: 100%;
}

.ag-menu {
  z-index: 200;
}

.toolbar button {
  margin-left: 5px;
  margin-right: 5px;
  padding: 2px;
}
</style>